<script>
import * as Sentry from '@sentry/browser';

import {
    GUIDE_CREATION_ERROR
} from "../../../shared/components/map-viewer/constants/map-events";
import {mapGetters, mapState} from 'vuex';

export default {
    name: "OExceptionsHandler",
    computed: {
        ...mapState({
            map: state => state.map
        }),
        ...mapGetters([
            'getDenormalisedObjectById',
            'gop',
            't',
        ]),
    },
    methods: {
        onGuideCreationError(guide){

            let from, to;

            if(guide?.from?.id)
                from = this.gop(guide.from.id, 'name', 'not found')
            else
                from = guide?.from?.unit

            if(guide?.to?.id)
                to = this.gop(guide.to.id, 'name', 'not found')
            else
                to = guide?.to?.unit

            console.error(`${this.map.name} :. Guide from ${from} to ${to} can't be created`, guide)

            Sentry.setTag("category", "guide");
            Sentry.setContext('guideData', guide)
            Sentry.captureMessage(`${this.map.name} -- Guide from ${from} to ${to} can't be created`, 'warning')
        },
    },
    created(){
        this.$bus.$on(GUIDE_CREATION_ERROR, this.onGuideCreationError);
    },
    beforeDestroy(){
        this.$bus.$off(GUIDE_CREATION_ERROR, this.onGuideCreationError);

    },
    render(){ return null }
}
</script>
